import BaseRequest from './base/BaseRequest'

export default class BithumbRequest extends BaseRequest {

  getOrderBook(symbol) {
    let url = `/bithumb/orderbook/${symbol}`;
    return this.get(url);
  }
}
